module.exports = __webpack_public_path__ + "img/reserve.467248d4.svg";